import React, { useEffect, useState } from 'react';
import { Modal } from 'reactstrap';
import { FaGear, FaPlus, FaMinus } from "react-icons/fa6";
import { GrUpgrade } from "react-icons/gr";
import { AiFillDollarCircle } from "react-icons/ai";
import { IoMdCloseCircleOutline } from "react-icons/io";
import httpService from '../../services/http.service';
import ErrorMessage from '../common/errorMsg';
import SuccessMessage from '../common/successMsg';

const UpdatePropertyModal = ({ isOpen, onCancel, onConfirm, initalQuantity }) => {
    const [updatePropertyData, setUpdatePropertyData] = useState({});
    const [loading, setLoading] = useState(false);
    const [updateSubscriptionLoader, setSubscriptionLoader] = useState(false)
    const [quantity, setQuantity] = useState(Number(initalQuantity));
    const userId = localStorage.getItem("UserId");

    const getUpdatePropertyData = async (qty = quantity) => {
        try {
            setLoading(true);
            const { data } = await httpService.CreateUpdate("/display-subscription-portion", {
                userId,
                newQuantity: qty
            });
            setUpdatePropertyData(data);
        } catch (error) {
            ErrorMessage("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            getUpdatePropertyData();
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen && quantity) {
            getUpdatePropertyData(quantity);
        }
    }, [quantity]);

    const handleQuantityChange = (change) => {
        const newQty = quantity + change;
        if (newQty > 0) setQuantity(newQty);
    };

    const updateQuantityHandler = async () => {
        try {
            setSubscriptionLoader(true);
            const { data } = await httpService.CreateUpdate("/update-subscription-cycle", {
                userId,
                newQuantity: quantity
            });
            SuccessMessage(data.message)
            onCancel(false)
            window.location.reload()

        } catch (error) {
            ErrorMessage("Something went wrong");
        } finally {
            setSubscriptionLoader(false)
        }
    }

    return (
        <Modal
            className="modal-xl"
            isOpen={isOpen}
            style={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <div style={{
                backgroundColor: "#fff",
                height: "100%",
                borderRadius: 12,
                padding: 20,
                width: "100%",
                boxShadow: "0 5px 15px rgba(0,0,0,0.1)"
            }}>
                {/* Header */}
                <div style={{ marginBottom: 20 }}>
                    <div style={{ display: "flex", gap: 10, alignItems: "center", justifyContent: "space-between" }}>
                        <div>
                            <div style={{ fontSize: 18, fontWeight: "bold" }}>
                                Upgrade Subscription
                            </div>
                            <div style={{ fontSize: 14, color: "#555" }}>
                                Increase your plan quantity
                            </div>
                        </div>
                        <IoMdCloseCircleOutline size={30} cursor="pointer" onClick={() => onCancel(false)} />
                    </div>
                </div>

                {/* Body */}
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#f2f4f8",
                    borderRadius: 10,
                    padding: 15
                }}>
                    {loading ? <div style={{ height: 260, display: "flex", justifyContent: "center", alignItems: "center" }}>Loading...</div> : (
                        <>
                            {/* Current Plan Section */}
                            <div style={{ display: "flex", gap: 10 }}>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: "flex", gap: 8, marginBottom: 10, alignItems: "center" }}>
                                        <FaGear size={18} />
                                        <p style={{ fontSize: 16, fontWeight: "bold", margin: 0 }}>Current Plan Details</p>
                                    </div>
                                    {[
                                        { label: "Plan Name", value: "RSD 1 Year Plan" },
                                        { label: "Current Quantity", value: updatePropertyData?.currentQuantity || 0 },
                                        { label: "Current Total", value: `$${updatePropertyData?.currentTotal || 0}/year` },
                                    ].map((item, idx) => (
                                        <div key={idx} style={{
                                            backgroundColor: "#fff",
                                            marginBottom: 8,
                                            borderRadius: 6,
                                            padding: "10px 15px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}>
                                            <span style={{ fontSize: 14, color: "#333" }}>{item.label}</span>
                                            <span style={{ fontSize: 14, fontWeight: "bold" }}>{item.value}</span>
                                        </div>
                                    ))}
                                </div>

                                {/* Cost Breakdown */}
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: "flex", gap: 8, marginBottom: 10, alignItems: "center" }}>
                                        <AiFillDollarCircle size={18} />
                                        <p style={{ fontSize: 16, fontWeight: "bold", margin: 0 }}>Cost Breakdown</p>
                                    </div>
                                    {[
                                        { label: "New Properties", value: `${updatePropertyData?.newQuantity || 0} Properties` },
                                        { label: "Per Price Properties", value: `$${updatePropertyData?.unitPrice || 0}/year` },
                                        { label: "Additional Cost", value: `+ $${updatePropertyData?.additionalCost || 0}` },
                                    ].map((item, idx) => (
                                        <div key={idx} style={{
                                            backgroundColor: "#fff",
                                            marginBottom: 8,
                                            borderRadius: 6,
                                            padding: "10px 15px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}>
                                            <span style={{ fontSize: 14, color: "#333" }}>{item.label}</span>
                                            <span style={{ fontSize: 14, fontWeight: "bold" }}>{item.value}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Upgrade Section */}
                            <div style={{ flex: 1 }}>
                                <div style={{ display: "flex", gap: 8, marginBottom: 10, alignItems: "center" }}>
                                    <GrUpgrade size={18} />
                                    <p style={{ fontSize: 16, fontWeight: "bold", margin: 0 }}>Property Upgrade</p>
                                </div>
                                <div style={{
                                    backgroundColor: "#fff",
                                    borderRadius: 6,
                                    padding: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 15,
                                    justifyContent: "center"
                                }}>
                                    <button disabled={updatePropertyData?.currentQuantity === quantity} onClick={() => handleQuantityChange(-1)} style={{
                                        height: 35,
                                        width: 35,
                                        backgroundColor: "#6c63ff",
                                        color: "white",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        outline: "none",
                                        border: "none"
                                    }}>
                                        <FaMinus size={14} />
                                    </button>
                                    <input
                                        type="text"
                                        readOnly
                                        value={quantity}
                                        style={{
                                            width: 60,
                                            textAlign: "center",
                                            padding: 8,
                                            border: "1px solid #ccc",
                                            borderRadius: 8,
                                            fontSize: 16
                                        }}
                                    />
                                    <button onClick={() => handleQuantityChange(1)} style={{
                                        height: 35,
                                        width: 35,
                                        backgroundColor: "#6c63ff",
                                        color: "white",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        outline: "none",
                                        border: "none"
                                    }}>
                                        <FaPlus size={14} />
                                    </button>
                                </div>
                                <div style={{ textAlign: "center", margin: "20px 0px",fontSize:17, color:"red" }}>
                                    Please note: If you upgrade your properties, the amount will be non-refundable.
                                </div>
                            </div>
                            <button onClick={() => updateQuantityHandler()} disabled={updatePropertyData?.currentQuantity === quantity} style={{ flex: 1, padding: 25, marginTop: 10, outline: "none", borderRadius: 10, border: "none", backgroundColor: updatePropertyData?.currentQuantity === quantity || updateSubscriptionLoader ? "#a7a7f0" : "blue", color: "white" }}>{updateSubscriptionLoader ? "Loading..." : "Upgrade Now"}</button>
                        </>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default UpdatePropertyModal;
